import React from 'react';
import EscolaConfigForm from '@/components/EscolaConfigForm';

const PerfilEscolaPage: React.FC = () => {
  return <EscolaConfigForm />;
};

export default PerfilEscolaPage; 